import _ from 'lodash';
import { GRAPH_OTHERS_KEY } from './useGraph';
import { SORT_BY_DIRECTIONS } from 'common/fetchHooks/useTableSortBy';

export const GRAPH_STACKING_TYPES = {
  PERCENT: {
    key: 'PERCENT',
    value: 'percent',
    isToggleable: false
  },
  NORMAL: {
    key: 'NORMAL',
    value: 'normal',
    isToggleable: true,
    icon: 'ChartStackedColumn'
  },
  SIDE_BY_SIDE: {
    key: 'SIDE_BY_SIDE',
    value: undefined,
    isToggleable: true,
    icon: 'ChartSideBySide'
  }
};

export const GRAPH_VIEWS = {
  PERCENT: {
    key: 'PERCENT',
    name: 'Percent',
    getConfig: ({ stackingType }) => ({
      getValue: ({ point }) => _.get(point, 'effort_p'),
      stacking: GRAPH_STACKING_TYPES.PERCENT.value,
      yAxis: {
        labelFormatter: ({ label }) => `${label.value}%`,
        max: 100
      }
    })
  },
  FTE: {
    key: 'FTE',
    name: 'FTE',
    getConfig: ({ stackingType }) => ({
      getValue: ({ point }) => _.get(point, 'effort_fte'),
      stacking: stackingType.value,
      yAxis: {
        labelFormatter: ({ label }) => `${label.value}`
      }
    })
  },
  COST: {
    key: 'COST',
    name: 'Cost',
    getConfig: ({ stackingType }) => ({
      getValue: ({ point, raCost }) => {
        const effortFte = _.get(point, 'effort_fte');
        const period = {
          before: _.get(point, 'end_period'),
          after: _.get(point, 'start_period')
        };
        return raCost.calculateCostByFte({ period, effortFte });
      },
      stacking: stackingType.value,
      yAxis: {
        labelFormatter: ({ label, raCost }) =>
          raCost.formatToString(label.value)
      }
    })
  }
};

export const orderGraphDataByKey = (
  data,
  key,
  dir = SORT_BY_DIRECTIONS.DESC
) => {
  const clonedData = _.cloneDeep(data);
  const totalKey = `total_${key}`;
  clonedData.forEach(item => {
    const total = item.allocation_data.reduce((acc, allocation) => {
      return acc + allocation[key];
    }, 0);
    item[totalKey] = total;
  });
  const orderedData = clonedData.sort((a, b) => {
    // "OTHERS" should always be last
    if (a.key?.toLowerCase() === GRAPH_OTHERS_KEY) return 1;
    if (b.key?.toLowerCase() === GRAPH_OTHERS_KEY) return -1;

    if (dir === SORT_BY_DIRECTIONS.DESC) return b[totalKey] - a[totalKey];
    if (dir === SORT_BY_DIRECTIONS.ASC) return a[totalKey] - b[totalKey];
  });

  return orderedData;
};
